import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { i18n } from '../../../../language';
import { ehandoverAPI } from '../../../../apis';
import ehandoverIds from '../../../../ids/Ehandover';
import useCheckLogin from '../../../../utils/useCheckLogin';
import AddComment from './addComment';
import Comment from './comment';

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: '0.0625rem solid #dddddd',
    padding: '1.875rem 1.875rem 1.875rem 1.938rem',
  },
  head: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    letterSpacing: '0.025rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    marginBottom: '0.938rem',
  },
  add: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    backgroundColor: '#fff',
    padding: '1rem 0 1rem 1.5rem',
    width: '100%',
    minWidth: '100px',
    textTransform: 'capitalize',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
}));

function Add({ id, control, setControl, classes, commentNeedLogin }) {
  const checkLogin = useCheckLogin();
  const handleComment = () => {
    if (commentNeedLogin && !checkLogin()) {
      return;
    } else {
      control ? setControl(false) : setControl(true);
    }
  };

  return (
    <div>
      <Button id={ehandoverIds.comment + id + 1} className={classes.add} onClick={handleComment}>
        {i18n.t('EHANDOVER_COMMENT_ADD_UPDATE')}
      </Button>
    </div>
  );
}

function Comments({
  id,
  noteIndex,
  deleted,
  commentsCount,
  TASK_ID,
  updateCommentsCountAPI,
  type,
  commentNeedLogin,
  staffList,
  onHeightChange = () => {},
  setFocusedIndex = () => {},
  resetFocusedIndex = () => {},
}) {
  const classes = useStyles();
  const [context, setContext] = useState('');
  const [control, setControl] = React.useState(false);
  const [comments, setComments] = useState([]);

  // get Comment API
  const getCommentAPI = async () => {
    try {
      const { result } = await ehandoverAPI.getCommentItem({ taskId: TASK_ID });
      setComments([...result]);
    } catch (error) {
      console.log('-----Complete taskItem error----->', error);
    }
  };

  useEffect(() => {
    (async () => {
      await getCommentAPI();
    })();
  }, [TASK_ID]);

  const data = useMemo(() => {
    let list = [];

    if (Array.isArray(comments) && comments.length > 0) {
      list = _.map(comments, (item) => {
        return {
          name: item.AUTHOR_NAME,
          context: item.POST_MESSAGE,
          time: moment(item.POST_DATE).isValid() ? item.POST_DATE : '',
          id: item.ID,
          files: item.ATTACHED_OBJECTS ?? {},
        };
      });

      list.sort(function (a, b) {
        return moment(b.time) - moment(a.time);
      });
    }

    return { list };
  }, [comments]);

  useEffect(() => {
    onHeightChange?.();
    if(control){
      setFocusedIndex();
    }
    
  }, [control, data]);

  return (
    <div className={classes.root}>
      <div className={classes.head}>{i18n.t('EHANDOVER_NOTE_UPDATE', { number: commentsCount ?? 0 })}</div>
      {type !== 'deleted' &&
        (control ? (
          <AddComment
            id={id}
            noteIndex={noteIndex}
            deleted={deleted}
            TASK_ID={TASK_ID}
            context={context}
            setContext={setContext}
            getCommentAPI={getCommentAPI}
            updateCommentsCountAPI={updateCommentsCountAPI}
            wardStaffdata={staffList}
            commentNeedLogin={commentNeedLogin}
            setControl={() => {
              setControl(false);
              resetFocusedIndex();
            }}
            onHeightChange={onHeightChange}
          />
        ) : (
          <Add
            id={id}
            control={control}
            setControl={setControl}
            classes={classes}
            commentNeedLogin={commentNeedLogin}
          />
        ))}
      {data.list.length > 0 &&
        data.list.map((item) => {
          return <Comment {...item} key={item.id} onHeightChange={onHeightChange} />;
        })}
    </div>
  );
}

const mapStateToProps = (state) => ({
  roleMap: state.roleMap,
});

export default connect(mapStateToProps)(Comments);
